module.exports = __webpack_public_path__ + "static/media/popup-cancel-icon.d3ca1c31.svg";